import { ApiRoute } from 'config';
import { FavoritesContext, ContextValue } from 'contexts/Favorites';
import createUseContextHook from './createUseContextHook';

const useFavorites = createUseContextHook<ContextValue>(
  // @ts-expect-error TODO: fix null safety
  FavoritesContext,
  ApiRoute.FAVORITES,
);

export default useFavorites;
